import HighlightContainer from 'flow/components/ui-components/HighlightContainer';
import Link from 'flow/components/ui-components/Link';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    onRetry?: () => void;
}

const TranscriptionQuotaExceeded = ({ onRetry }: Props) => {
    const { i18next } = useAppContext();

    return (
        <HighlightContainer
            type="warning"
            title={i18next.t('ai.transcript.quota_exceeded')}
            body={
                <div>
                    {i18next.t('ai.transcript.quota_exceeded_description')}
                    {onRetry && (
                        <>
                            {' '}
                            <Link onClick={onRetry}>
                                {i18next.t('ai.transcript.try_again')}
                            </Link>
                        </>
                    )}
                </div>
            }
        />
    );
};

export default TranscriptionQuotaExceeded;
